import { getCountry, getProvince, getCity, getDistrict, getStreet } from '../api/area.js';
/**
 * 1.以下是国家、省份、城市的接口
 * 2.使用方式如下：
 * getCountrys().then(res => {
 *    this.option = res;
 * });
 * **/
// 用于下拉select的方法
export async function getCountrys() {
    const result = await getCountry({ pageSize: 500, pageNo: 1 }).then(res => {
        if (res && +res.code === 0) {
            const arr = [];
            // const data = res.data.list;
            const data = res.data;
            data.forEach(e => {
                // 筛除台湾、香港、澳门
                if (['TW', 'HK', 'MO'].includes(e.ebplCode)) {
                    return false;
                }
                const item = { value: e.ebplCode, label: e.ebplNameCn };
                // ebplCode === '100000' 为中国，将中国选项加到第一位
                e.ebplCode === '100000' ? arr.unshift(item) : arr.push(item);
            });
            return arr;
        } else {
            return [];
        }
    });
    return result;
}

export async function getProvinces(ebplParentPmCode) {
    const result = await getProvince({ ebplParentPmCode: ebplParentPmCode }).then(res => {
        if (res && +res.code === 0) {
            const arr = [];
            const data = res.data;
            data.forEach(e => {
                arr.push({
                    value: e.ebplCode,
                    label: e.ebplNameCn,
                    pmCode: ebplParentPmCode
                });
            });
            return arr;
        } else {
            return [];
        }
    });
    return result;
}

export async function getCitys(ebplParentPmCode) {
    const result = await getCity({ ebplParentPmCode: ebplParentPmCode }).then(res => {
        if (res && +res.code === 0) {
            const arr = [];
            const data = res.data;
            data.forEach(e => {
                arr.push({
                    value: e.ebplCode,
                    label: e.ebplNameCn,
                    pmCode: ebplParentPmCode
                });
            });
            return arr;
        } else {
            return [];
        }
    });
    return result;
}

export async function getDistricts(ebplParentPmCode) {
    const result = await getDistrict({ ebplParentPmCode: ebplParentPmCode }).then(res => {
        if (res && +res.code === 0) {
            const arr = [];
            const data = res.data;
            data.forEach(e => {
                arr.push({
                    value: e.ebplCode,
                    label: e.ebplNameCn,
                    pmCode: ebplParentPmCode
                });
            });
            return arr;
        } else {
            return [];
        }
    });
    return result;
}

export async function getStreets(ebplParentPmCode) {
    const result = await getStreet({ ebplParentPmCode: ebplParentPmCode }).then(res => {
        if (res && +res.code === 0) {
            const arr = [];
            const data = res.data;
            data.forEach(e => {
                arr.push({
                    value: e.ebplCode,
                    label: e.ebplNameCn,
                    pmCode: ebplParentPmCode
                });
            });
            return arr;
        } else {
            return [];
        }
    });
    return result;
}

// 获取常用的省份
export async function getCommonProvinces(ebplParentPmCode) {
    const result = await getProvince({ ebplParentPmCode: ebplParentPmCode }).then(res => {
        if (res && +res.code === 0) {
            const arr = [];
            let codes = window.localStorage.getItem('COMMON_PROVINCE_CODES');
            const data = res.data;
            codes = codes ? codes.split(',') : [];
            codes.forEach(code => {
                const e = data.find(item => {
                    return item.ebplCode === code;
                });
                if (e) {
                    arr.push({
                        value: e.ebplCode,
                        label: e.ebplNameCn,
                        pmCode: ebplParentPmCode
                    });
                }
            });
            data.forEach(e => {
                if (codes.indexOf(e.ebplCode) < 0) {
                    arr.push({
                        value: e.ebplCode,
                        label: e.ebplNameCn,
                        pmCode: ebplParentPmCode
                    });
                }
            });
            return arr;
        } else {
            return [];
        }
    });
    return result;
}

// 获取常用的城市
export async function getCommonCitys(ebplParentPmCode) {
    const result = await getCity({ ebplParentPmCode: ebplParentPmCode }).then(res => {
        if (res && +res.code === 0) {
            const arr = [];
            let codes = window.localStorage.getItem('COMMON_CITY_CODES');
            const data = res.data;
            codes = codes ? codes.split(',') : [];
            codes.forEach(code => {
                const e = data.find(item => {
                    return item.ebplCode === code;
                });
                if (e) {
                    arr.push({
                        value: e.ebplCode,
                        label: e.ebplNameCn,
                        pmCode: ebplParentPmCode
                    });
                }
            });
            data.forEach(e => {
                if (codes.indexOf(e.ebplCode) < 0) {
                    arr.push({
                        value: e.ebplCode,
                        label: e.ebplNameCn,
                        pmCode: ebplParentPmCode
                    });
                }
            });
            return arr;
        } else {
            return [];
        }
    });
    return result;
}

// 设置常用的行政区(省份|城市)码
export function setCommonRegionCode(code, type) {
    const storageObj = {
        provinceCode: 'COMMON_PROVINCE_CODES',
        cityCode: 'COMMON_CITY_CODES'
    };
    let codes = window.localStorage.getItem(storageObj[type]);
    codes = codes ? codes.split(',') : [];
    const startNum = codes.indexOf(code);
    if (startNum > -1) {
        codes.splice(startNum, 1);
    }
    codes.unshift(code);
    window.localStorage.setItem(storageObj[type], codes);
}